const GA_TRACKING_ID = 'UA-78262041-5';

/**
 * Function that returns the value of a cookie
 * {@link https://bit.ly/34cDU2F}.
 * @param {string} a - cookie name.
 * @return {string} - Returns the cookie value or '' if not found.
 */
export function getCookie(a) {
  const b = document.cookie.match(`(^|[^;]+)\\s*${a}\\s*=\\s*([^;]+)`);
  return b ? b.pop() : '';
}

export {
  GA_TRACKING_ID, //eslint-disable-line
};
